import { deleteUser } from '../../../api/ans';
import { closePopup, openPopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import GreyButton from '../../ui/buttons/greyButton/GreyButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function DeletePopup() {
  const dispatch = useAppDispatch();
  // const error = useAppSelector((state) => state.orders.error); //можно будет выводить ошибку в попап
  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const handleYes = () => {
    deleteUser()
      .then((value) => {
        console.log('Запрос успешно доставлен:', value);
        dispatch(openPopup('deleteAccountSuccess'));
      })
      .catch((error) => {
        console.error('❌ Ошибка при запросе на удаление:', error);
        dispatch(openPopup('deleteAccountFail'));
      });
  };

  return (
    <div className={styles.stockCommentPopupWrapper}>
      <div className={styles.topRow}>
        <h3 className={styles.stockCommentTitle}>
          Будет сформирован запрос на удаление аккаунта, данные будут удалены в течении 24
          ч. и восстановить будет невозможно. Вы уверены?
        </h3>
        <button
          className={styles.closePopupButton}
          onClick={handleClosePopup}
          aria-label="Закрыть"
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', width: '100%' }}>
        <RedButton text="Нет" width="100%" height={50} onClick={handleClosePopup} />
        <GreyButton text="Да" width="100%" height={50} onClick={handleYes} />
      </div>
    </div>
  );
}

export default DeletePopup;
